import axios from "axios";
import Element from "element-ui";
import router from "./router";
// 如果上传国外国内版本的时候，需要全局更改不同的这个URL
// http://app.duhongtech.com:9082/sight 替换换为 http://api.gw.duhongtech.com/sight (结尾带/防止替换错)
// export const baseURL ="https://api.gw.duhongtech.com/sight";
// export const baseURL ="http://127.0.0.1:9082/sight"
export const baseURL = "http://app.duhongtech.com:9082/sight";
axios.defaults.baseURL = baseURL


//
const request = axios.create({
  timeout: 500000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});
request.interceptors.request.use((config) => {
  config.headers["token"] = localStorage.getItem("token"); // 请求头带上token
  return config;
});
request.interceptors.response.use(
  (response) => {
    let res = response.data;
    // console.log("response")
    // console.log(res)
    if (res.code === "0000") {
      return response;
    } else {
      Element.Message.error(res.msg ? res.msg : "系统异常！", {
        duration: 3 * 1000,
      });
      if (res.code == "401") {
        return router.push("/login");
      } else {
        return Promise.reject(response.data.msg);
      }
    }
  }
  // error => {
  //     console.log(error)
  //     if(error.response.data) {
  //         error.message = error.response.data.msg
  //     }
  //     if(error.response.status === 401) {
  //         router.push("/login")
  //     }
  //     Element.Message.error(error.message, {duration: 3 * 1000})
  //     return Promise.reject(error)
  // }
);
export default request;
